<template>
  <div class="tree">
    <div>
      <div v-for="(item, index) in state.list" :key="index">
        <div class="txtswrap">
          每一层
          <span class="txts">{{item.sectionName}}</span>
          <img
            class="vimg"
            src="https://huilefu-gh5.oss-cn-beijing.aliyuncs.com/qjzx/img/ins/play.png"
            alt
          />
        </div>
        <van-divider />
        <Tree v-if="item?.childList?.length" :data="item.childList" />
      </div>
    </div>
    <!-- <div v-for="(item, index) in state.list" :key="index">
      <div>每一层 {{ item.name }}</div>
      <Tree v-if="item?.children?.length" :data="item.children" />
    </div>-->
  </div>
</template>
<script>
import { ref, reactive, getCurrentInstance, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
export default {
  props: {
    data: {
      type: Array,
    },
  },
  updated() {},
  onMounted() {},
  setup(props, context) {
    const router = useRouter()
    onMounted(() => {
      console.log(props.data)
      state.list = props.data
    })
    const state = reactive({
      list: [],
      activeNames: ['1', '2', '3'],
    })
    return {
      state,
    }
  },
}
</script>

<style lang="scss" scoped>
.tree {
  margin-left: 20px;
}
.txts {
  font-size: 13px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
}
.vimg {
  width: 16px;
  height: 16px;
  float: right;
  margin-right: 10px;
}
.txtswrap {
  font-size: 13px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  overflow: hidden;
}
</style>
